module.exports = __webpack_public_path__ + "static/media/photo_1.08e7b430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_1.jpg
// module id = 1634
// module chunks = 0